<eda-dialog2 [header]="dialogHeader" width="70dvw" [height]="dialogHeight" (apply)="onApply()" [disableApply]="disableApply()"
    [overflow]="'auto'"  [showDelete]=true (delete)="onDelete()" (close)="onClose()">

    <div content content class="p-6">
      <!-- Filter Details -->
      <div class="border rounded-lg shadow-sm">
        <div class="p-4 space-y-4">
          <div class="flex items-center justify-between">
            <h3 class="text-lg font-bold" i18n="@@filterOptions">
              Opciones del filtro:
            </h3>
          </div>
    
          <div class="grid grid-cols-4 items-center">
            <div class="space-x-2 flex items-center h-max">
              <label i18n="@@aplyToAllPanelsH5" [pTooltip]="tooltipApplyToAll" tooltipPosition="top">¿Aplica a todos los paneles?</label>
              <button type="button" role="switch" [attr.aria-checked]="applyToAll" (click)="applyToAllCheck()"
                class="peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50"
                [ngClass]="{'bg-[var(--corporate-primary)]': applyToAll, 'bg-input': !applyToAll}">
                <span
                  class="pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform"
                  [ngClass]="{'translate-x-5': applyToAll, 'translate-x-0': !applyToAll}"></span>
              </button>
            </div>
    
            <div class="space-x-2 flex items-center h-max">
              <label i18n="@@autocompleteFilter" [pTooltip]="tooltipAutocomplete" tooltipPosition="top">¿Filtro autocomplete?</label>
              <button type="button" role="switch" [attr.aria-checked]="isAutocompleted"
                (click)="autocompleteFilterCheck(this)"
                class="peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50"
                [ngClass]="{'bg-[var(--corporate-primary)]': isAutocompleted, 'bg-input': !isAutocompleted}">
                <span
                  class="pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform"
                  [ngClass]="{'translate-x-5': isAutocompleted, 'translate-x-0': !isAutocompleted}"></span>
              </button>
            </div>

            <div class="space-x-2 flex items-center h-max">
              <label i18n="@@mandatoryFilter" [pTooltip]="tooltipMandatory" tooltipPosition="top">¿Filtro obligatorio?</label>
              <button type="button" role="switch" [attr.aria-checked]="isMandatory"
                (click)="mandatoryFilterCheck(this)"
                class="peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50"
                [ngClass]="{'bg-[var(--corporate-primary)]': isMandatory, 'bg-input': !isMandatory}">
                <span
                  class="pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform"
                  [ngClass]="{'translate-x-5': isMandatory, 'translate-x-0': !isMandatory}"></span>
              </button>
            </div>

            <div>
              <div class="flex flex-row space-x-1.5 items-center">
                <label class="flex-none" [pTooltip]="tooltipVisibility" tooltipPosition="top">{{header4}}:</label>
                <div class="relative flex-grow">
                  <p-dropdown 
                    [options]="publicRoHidden" [(ngModel)]="globalFilter.visible"
                    i18n-title="@@filterVisibleScope" title="..."
                    [style]="{'width': '100%'}" selected="publicRoHiddenOption">
                  </p-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

        <!-- <div class="w-full "> -->
      @if (formReady && !globalFilter.isdeleted) {
        <div class="border rounded-lg shadow-sm mt-4">
          <div class="p-4 space-y-4">
            <div class="flex items-center justify-between">
              <h3 class="text-lg font-bold">{{header3}}:</h3>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            <p-dropdown
              [options]="tables"
              optionLabel="display_name.default"
              [style]="{ width: '100%' }"
              [(ngModel)]="globalFilter.selectedTable"
              filter="true"
              i18n-placeholder="@@placeholderTables"
              placeholder="Entidades"
              (onChange)="onChangeSelectedTable()"
              appendTo="body"
            >
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <div>{{ selectedOption?.display_name?.default }}</div>
              </ng-template>
              <ng-template let-table pTemplate="item">
                <div>{{ table?.display_name?.default }}</div>
              </ng-template>
            </p-dropdown>

  
              <p-dropdown
                [options]="columns"
                optionLabel="display_name.default"
                [style]="{ width: '100%' }"
                [(ngModel)]="globalFilter.selectedColumn"
                filter="true"
                i18n-placeholder="@@atributosH4"
                placeholder="Atributos"
                (onChange)="onChangeSelectedColumn()"
                appendTo="body"
              >
                <ng-template pTemplate="selectedItem" let-selectedOption>
                  <div>{{ selectedOption?.display_name?.default }}</div>
                </ng-template>
                <ng-template let-column pTemplate="item">
                  <div>{{ column?.display_name?.default }}</div>
                </ng-template>
              </p-dropdown>


              <input class="h-[3.2rem] w-full rounded-md border px-2 py-4"
                [(ngModel)]="aliasValue"
                i18n-placeholder="@@aliasValuePh"
                placeholder="Alias del filtro (opcional)"
              />

              @if (globalFilter.selectedColumn?.column_type !== 'date') {
                @if(globalFilter.isAutocompleted === false){
                  <p-multiSelect id="selectFilterValue" class='eda-filter-multiselect' [options]="columnValues"
                    [(ngModel)]="globalFilter.selectedItems" [virtualScroll]="true" [itemSize]="30"
                    [style]="{ width: '100%', height:'100%', alignItems:'center'}" [panelStyle]="{minWidth:'15em'}"
                    [maxSelectedLabels]="1" i18n-defaultLabel="@@defaultValueLabel" defaultLabel="Valor por defecto" [loading]="loading"
                    display="chip" appendTo="body">
                  </p-multiSelect>
                }@else{
                  <p-autoComplete [(ngModel)]="globalFilter.selectedItems" (keydown.enter)="onAddValue($event, globalFilter)"
                    [suggestions]="autoCompleteValues" (completeMethod)="loadFilterAutoComplete($event, globalFilter)" placeholder="abc..."
                    [forceSelection]="false" [multiple]="true" (onSelect)="onItemSelected(globalFilter)" (onUnselect)="onItemSelected(globalFilter)"
                    class="modern-autocomplete flex-1">
                  </p-autoComplete>
                }
              }
              @if (globalFilter.selectedColumn?.column_type === 'date') {
                <eda-date-picker #myCalendar
                  [inject]="datePickerConfigs[globalFilter?.id]"
                  [autoClear]="true" (onDatesChanges)="processPickerEvent($event)">
                </eda-date-picker>
              }
            </div>
          </div>
        </div>
      }

        <!-- <p-card *ngIf="formReady && !globalFilter.isdeleted" [header]="header4" id="anywhereClick">
          <p-dropdown id="applyToOneFilterDropdown" i18n-title="@@filterVisibleScope"
            title="Definir la visibilidad del filtro. Público: todos pueden usarlo.  Deshabilitado: El resto de usuarios pueden ver el filtro pero no pueden modificarlo.  Oculto: El resto de usuarios no pueden ver el filtro, pero se les aplica"
            [options]="publicRoHidden" [(ngModel)]="globalFilter.visible"
            [style]="{'width': '100%'}" selected="publicRoHiddenOption" autoWidth="false">
          </p-dropdown>
        </p-card> -->
        <!-- </div> -->

      <!-- Panel Selection -->
      @if (formReady && !globalFilter.isdeleted) {
        @if (globalFilter.queryMode == 'EDA') {
          @if (!applyToAll) {
            <div class="border rounded-lg shadow-sm mt-4">
              <div class="p-4 space-y-4">
                <h3 class="text-lg font-bold">{{header2}}:</h3>
                
                <div class="w-full"> 
                    <div class="grid grid-cols-2 sm:grid-cols-4 gap-2">
                      @for (panel of allPanels; track panel.id) {
                        <span
                          [pTooltip]="isPanelReadOnly(panel) ? 'Panel importado de otro dashboard. Ajusta la configuración desde el mapeador de filtros.' : null"
                          tooltipPosition="top"
                        >
                          <button
                            (click)="togglePanel(panel)"
                            class="flex items-center justify-start w-full h-auto py-2 px-3 rounded-md font-medium transition-colors"
                            [ngClass]="{
                              'bg-gray-200 text-gray-600 cursor-not-allowed': isPanelReadOnly(panel),
                              'bg-[var(--corporate-primary)] text-white': isPanelSelected(panel)
                            }"
                            [class.border]="!isPanelSelected(panel)"
                            [class.border-gray-300]="!isPanelSelected(panel)"
                            [disabled]="isPanelReadOnly(panel)"
                          >
                            @if (isPanelSelected(panel.id)) {
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 h-4 w-4 shrink-0">
                                <polyline points="20 6 9 17 4 12"/>
                              </svg>
                            }
                            <span class="truncate">{{ panel.title }}</span>
                          </button>
                      </span>
                      }
                    </div>
                </div>
              </div>
            </div>
          }
        } @else if (globalFilter.queryMode == 'EDA2') {
          @if (!isEmpty(globalFilter.selectedTable) && !isEmpty(globalFilter.selectedColumn)) {
            <div class="border rounded-lg shadow-sm mt-4">
              <div class="p-4 space-y-4">
                <h3 class="text-lg font-bold">{{header2}}:</h3>

                <div class="w-full overflow-hidden rounded-md border border-gray-200 gf-panel-table">
                  <!-- Table header -->
                  <div class="grid grid-cols-2 bg-[#f8f9fa] border-b border-[#e9ecef] px-4 py-2.5 text-sm font-semibold text-[#6c757d]">
                    <span i18n="@@panelColHeader">Panel</span>
                    <span i18n="@@filterPathColHeader">Ruta del filtro</span>
                  </div>

                  <!-- Panel rows -->
                  @for (panel of allPanels; track panel.id) {
                    <div class="grid grid-cols-2 items-center px-4 py-2.5 border-b border-gray-100 last:border-b-0 transition-colors"
                         [ngClass]="{
                           'bg-teal-50':  panel.active && panel.avaliable,
                           'bg-red-50':   !panel.avaliable,
                           'bg-white':    panel.avaliable && !panel.active
                         }">

                      <!-- Panel name + status dot -->
                      <div class="flex items-center gap-2.5 min-w-0">
                        <span class="w-2.5 h-2.5 rounded-full flex-shrink-0"
                              [ngClass]="{
                                'bg-[var(--corporate-primary)]': panel.active && panel.avaliable,
                                'bg-red-400':   !panel.avaliable,
                                'bg-gray-300':  panel.avaliable && !panel.active
                              }">
                        </span>
                        <button type="button"
                          (click)="onAddPanelForFilter(panel)"
                          class="text-sm text-left truncate transition-colors"
                          [ngClass]="{
                            'font-semibold text-[#00897B]': panel.active && panel.avaliable,
                            'text-red-400 cursor-not-allowed opacity-60': !panel.avaliable,
                            'text-gray-700 hover:text-[var(--corporate-primary)]': panel.avaliable && !panel.active
                          }"
                          [disabled]="!panel.avaliable">
                          {{ panel.title }}
                        </button>
                      </div>

                      <!-- TreeSelect -->
                      <div class="min-w-0 w-full">
                        @if(globalFilter.pathList[panel.id]){
                          <p-treeSelect class="w-full block"
                            [(ngModel)]="globalFilter.pathList[panel.id].selectedTableNodes"
                            [options]="panel.content.globalFilterPaths"
                            (onNodeExpand)="onNodeExpand(panel, $event)"
                            (onNodeSelect)="onNodeSelect(panel, $event)" appendTo="body"
                            styleClass="w-full"
                            panelStyleClass="eda-treeselect-panel"
                            [style]="{'width': '100%', 'min-width': '180px'}"
                            [panelStyle]="{'min-width': '260px'}"
                            [disabled]="!panel.active || !panel.avaliable">

                            <ng-template pTemplate="value">
                              <span class="d-flex align-items-center" [innerHTML]="getDisplayPathStr(globalFilter.pathList[panel.id].selectedTableNodes)"></span>
                            </ng-template>

                            <ng-template let-node pTemplate="child">
                              <span [ngClass]="checkNodeSelected(globalFilter.pathList[panel.id].selectedTableNodes, node) ? 'font-weight-bold' : ''"> {{node?.label}} </span>
                            </ng-template>

                            <ng-template let-node pTemplate="default">
                              <b>{{node?.label}}</b>
                            </ng-template>
                          </p-treeSelect>
                        }
                      </div>
                    </div>
                  }
                </div>

                <!-- Legend -->
                <div class="flex flex-wrap items-center gap-5 pt-1 text-sm text-gray-600">
                  <div class="flex items-center gap-1.5">
                    <span class="w-2.5 h-2.5 rounded-full bg-[var(--corporate-primary)] flex-shrink-0"></span>
                    <span>{{greendot}}</span>
                  </div>
                  <div class="flex items-center gap-1.5">
                    <span class="w-2.5 h-2.5 rounded-full bg-red-400 flex-shrink-0"></span>
                    <span>{{reddot}}</span>
                  </div>
                  <div class="flex items-center gap-1.5">
                    <span class="w-2.5 h-2.5 rounded-full bg-gray-300 flex-shrink-0"></span>
                    <span>{{unselecteddot}}</span>
                  </div>
                </div>

              </div>
            </div>
          }
        }
      }

    </div>
</eda-dialog2>